<template>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step
          :complete="step > 1"
          step="1"
        ></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="step > 2"
          step="2"
        ></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="step > 3"
          step="3"
        ></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="step > 4"
          step="4"
        ></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="5"></v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step='1' class="pa-0">
          <v-form>
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-container>
                  <v-layout align-center justify-center column >
                    <v-fade-transition leave-absolute>
                      <v-progress-circular
                        v-if="loading"
                        size="24"
                        color="info"
                        indeterminate
                      ></v-progress-circular>
                      <v-avatar
                        v-else
                        color="transparent"
                        size="120">
                        <img :src="require('@/assets/logomarca.png')" alt="trevor">
                      </v-avatar>
                    </v-fade-transition>
                    <v-flex xs12 class="pb-3">
                      <h3 class="display-1 font-weight-light grey--text mb-2">Insira o email do representante</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="representante_model.email"
                        outline
                        clearable
                        label="Email do representante"
                        type="text"
                      >
                      </v-text-field>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions color="red" class="info">
                  <v-spacer></v-spacer>
                  <v-btn flat dark @click.prevent="verificarEmail">
                  consultar email
                    <v-icon right>find_replace</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step='2' class="pa-0">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex
                      xs5
                    >
                      <v-text-field
                        label="Nome"
                        v-model="representante_model.nome"
                        hint="Insira o primeiro nome"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs7
                    >
                      <v-text-field
                        label="Sobrenome"
                        v-model="representante_model.sobrenome"
                        hint="Insira o sobrenome"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-select
                        v-model="representante_model.sexo"
                        :items="itemSexo"
                        item-text="texto"
                        item-value="val"
                        label="Sexo"
                      ></v-select>
                    </v-flex>
                    <v-flex xs9>
                      <v-text-field
                        v-model="representante_model.email"
                        readonly
                        label="E-mail"
                        required
                      ></v-text-field>

                      <v-alert v-model="alert" type="error" outline>
                        <h4>E-mail já cadastrado!</h4>Insira um novo e-mail.
                      </v-alert>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="representante_model.telefone"
                        :rules="contato1Rules"
                        mask="(##)#####-####"
                        label="Telefone"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs6
                    >
                      <v-text-field
                        v-model="representante_model.cpf"
                        :rules="repCpfRules"
                        label="CPF"
                        mask="###.###.###-##"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="verificacaoTelefone.cadastrado || (verificacaoTelefone.pessoa && representante_model && verificacaoTelefone.pessoa.id_pessoa !=  representante_model.id_pessoa)">
                      <v-card class="ma-2" elevation="4">
                        <v-card-title class="justify-center">
                          <h4
                            v-if="verificacaoTelefone.cadastrado || verificacaoTelefone.pessoa"
                            class="text-xs-center error--text"
                          >
                            Esse telefone já foi cadastrado
                          </h4>
                        </v-card-title>
                        <v-card-text>
                          <v-flex
                            class="error--text"
                            v-if="verificacaoTelefone.quantidade > 0"
                          >
                            {{ verificacaoTelefone.quantidade }} {{ verificacaoTelefone.quantidade === 1 ? 'pessoa cadastrou esse telefone' : 'pessoas cadastraram esse telefone' }}
                          </v-flex>
                          <v-flex
                            class="error--text"
                            v-if="verificacaoTelefone.ids_cadastrados.length > 0"
                          >
                            IDs que registraram esse telefone: <span v-for="(fone, index) in verificacaoTelefone.ids_cadastrados" :key="index">
                              {{ fone }}<span v-if="index < verificacaoTelefone.ids_cadastrados.length - 1 ">,</span>
                            </span>
                          </v-flex>
                          <v-layout wrap justify-space-between v-if="verificacaoTelefone.pessoa" class="error--text">
                            <v-flex xs12><h4 class="text-xs-center">Cadastro Firebase</h4></v-flex>
                            <v-flex xs11>Nome: {{ verificacaoTelefone.pessoa.nome_completo }}</v-flex>
                            <v-flex xs5>CPF: {{ verificacaoTelefone.pessoa.cpf }}</v-flex>
                            <v-flex xs5>ID: {{ verificacaoTelefone.pessoa.id_pessoa }}</v-flex>
                            <v-flex xs11>E-mail: {{ verificacaoTelefone.pessoa.email }}</v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions class="info">
                  <v-spacer></v-spacer>
                  <v-btn flat dark @click.prevent="salvarUsuario">
                  Salvar representante
                    <v-icon right>save</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step='3' class="pa-0">
          <v-form ref="form2" v-model="valid" lazy-validation>
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-container grid-list-md>
                    <h2 class="mt-4">Endereço do Representante
                      <v-icon>home</v-icon>
                    </h2>
                    <v-layout row wrap>
                    <v-flex xs4>
                      <v-text-field
                        @keyup="searchCepRepresentante"
                        v-model="representante_model.cep"
                        maxlength="8"
                        label="Cep"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="representante_model.logradouro"
                        label="Logradouro"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        v-model="representante_model.numero"
                        label="Nº"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9>
                      <v-text-field
                        v-model="representante_model.complemento"
                        label="Complemento"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="representante_model.bairro"
                        label="Bairro"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="representante_model.cidade"
                        label="Cidade"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        v-model="representante_model.uf"
                        label="UF"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions class="info">
                  <v-btn flat dark @click.prevent="salvarEndereco">
                  Salvar endereco
                    <v-icon right>save</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat dark @click.prevent="step++">
                  PULAR
                  </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step='4' class="pa-0">
          <v-form ref="form3" v-model="valid" lazy-validation>
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <div class="pl-3">
                  <h3 class="display-1 font-weight-light orange--text mb-2">Cadastro do posto</h3>
                </div>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm6
                      md4
                    >
                      <v-text-field
                        label="Nome fantasia"
                        v-model="posto_model.nome_fantasia"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm8
                    >
                      <v-text-field
                        :rules="razaoRules"
                        label="Razão Social"
                        v-model="posto_model.razao_social"
                        hint="Insira o nome oficial do CNPJ"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                    >
                      <v-text-field
                        v-model="posto_model.cnpj"
                        :rules="cnpjRules"
                        label="Cnpj"
                        mask="##.###.###/####-##"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        @keyup="searchCepPosto"
                        v-model="posto_model.cep"
                        maxlength="8"
                        label="Cep"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="posto_model.logradouro"
                        label="Logradouro"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        v-model="posto_model.numero"
                        label="Nº"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="posto_model.complemento"
                        label="Complemento"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="posto_model.bairro"
                        label="Bairro"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="posto_model.cidade"
                        label="Cidade"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        v-model="posto_model.uf"
                        label="UF"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  @click="salvarPosto"
                >
                  Salvar e continuar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step='5' class="pa-0">
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <div class="pl-3">
                  <h3 class="display-1 font-weight-light grey--text mb-2">Posto Inserido</h3>
                  <div class="font-weight-light title mb-2">
                    Confirme e peça que verifique a caixa de email
                  </div>
                </div>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card color="grey lighten-3" class="primary--text pe-3">
                        <v-layout>
                          <v-flex xs3 class="pt-4 pl-4">
                            <v-layout align-center justify-center column >
                              <v-avatar
                                color="grey"
                                size="60">
                                  <img v-if="representante_model.url_imagem_perfil" :src="representante_model.url_imagem_perfil" alt="trevor">
                                  <v-icon dark v-else>face</v-icon>
                              </v-avatar>
                            </v-layout>
                          </v-flex>
                          <v-flex xs9>
                            <v-card-title  class="text-xs-right">
                              <div>
                                <div class="headline">{{ representante_model.nome }}</div>
                                <div>{{ representante_model.email }}</div>
                                <div>CPF: {{ representante_model.cpf }}</div>
                                <div>CNPJ do Posto: {{ posto_model.cnpj }}</div>
                              </div>
                            </v-card-title>
                          </v-flex>
                        </v-layout>
                        <v-card-actions class="pa-2 info">
                          <v-spacer></v-spacer>
                          <v-btn flat dark @click.prevent="confirmarCadastro">
                            Confirmar cadastro
                            <v-icon right>check</v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
</template>

<script>

export default {
  data () {
    return {
      loading: false,
      validStep1: true,
      step: 1,
      alert: false,
      valid: true,
      dialogErro: false,
      menu: false,
      date: null,
      verificacaoTelefone: {
        cadastrado: false,
        quantidade: 0,
        ids_cadastrados: [],
        pessoa: undefined
      },
      posto_model: {
        checkbox: false,
        razao_social: '',
        cnpj: '',
        nome_fantasia: '',
        cep: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        uf: '',
        contato1: '',
        contato2: '',
        contato3: '',
        rep_nome: '',
        email: '',
        latitude: null,
        longitude: null
      },
      representante_model: {
        nome: '',
        sobrenome: '',
        cnpj: null,
        cpf: '',
        email: '',
        dataNasc: '',
        sexo: '',
        telefone: '',
        cep: '',
        logradouro: '',
        bairro: '',
        numero: '',
        complemento: '',
        cidade: '',
        estado: '',
        pais: 'Brasil'
      },
      itemSexo: [
        { texto: 'M.', val: 'M' },
        { texto: 'F.', val: 'F' }
      ],
      razaoRules: [
        v => !!v || 'Insira Razão Social!'
      ],
      cnpjRules: [
        v => !!v || 'Insira Cnpj!'
      ],
      contato1Rules: [v => !!v || 'Contato obrigatório!'],
      repCpfRules: [v => !!v || 'CPF obrigatório!']
    }
  },
  methods: {
    fechar () {
      this.$refs.form.reset()
      this.$refs.form2.reset()
      this.$refs.form3.reset()
      this.step = 1
      this.$emit('fechar')
    },
    confirmarCadastro () {
      this.$emit('info', 'Posto cadastrado com sucesso')
      if (!this.representante_model.id_pessoa) {
        this.sendmailcadposto()
      }
      this.fechar()
    },
    searchCepPosto () {
      fetch(`https://viacep.com.br/ws/${this.posto_model.cep}/json/`, {
        method: 'get',
        mode: 'cors',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(res => res.json())
        .then(json => {
          this.posto_model.logradouro = json.logradouro
          this.posto_model.bairro = json.bairro
          this.posto_model.cidade = json.localidade
          this.posto_model.uf = json.uf
        })
    },
    searchCepRepresentante () {
      fetch(`https://viacep.com.br/ws/${this.representante_model.cep}/json/`, {
        method: 'get',
        mode: 'cors',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(res => res.json())
        .then(json => {
          this.representante_model.logradouro = json.logradouro
          this.representante_model.bairro = json.bairro
          this.representante_model.cidade = json.localidade
          this.representante_model.uf = json.uf
        })
    },
    sendmailcadposto () {
      let mailposto = {
        message: `<!DOCTYPE html><html><head><style>.card {box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);max-width: 600px;margin: auto;text-align: center;font-family: arial;}.price {color: grey;font-size: 22px;}.card a{text-decoration: none;color: #4169E1;}.card button {border: none;outline: 0;padding: 12px;color: white;background-color: #000080;text-align: center;cursor: pointer;width: 100%;font-size: 18px;}.card button:hover {opacity: 0.7;}</style><body><h2 style="text-align:center"><img src="https://www.apetrus.com.br/_img/logop.png" alt=""></h2><div class="card"><img src="https://www.apetrus.com.br/_img/bannercli.png" alt="" style="width:100%"><h1>Parabéns!</h1><p class="price">Falta pouco para você aproveitar todas as nossas <a href="https://www.apetrus.com.br/posto.html" target="_blank">vantagens</a>.</p><p>Click em "Concluir Cadastro" para gerar sua senha de acesso ao sistema Apetrus.</p><p><a href="https://app.apetrus.com.br/userpasswordconf/?email=${this.representante_model.email}"><button>Concluir Cadastro</button></a></p></div></body></html>`,
        assunto: 'Bem vindo a Apetrus',
        to: this.representante_model.email
      }
      this.$store.dispatch('emailCliente', mailposto)
    },
    salvarUsuario () {
      if (this.$refs.form.validate()) {
        let body = {
          nome: this.representante_model.nome,
          sobrenome: this.representante_model.sobrenome,
          email: this.representante_model.email,
          telefone: this.representante_model.telefone,
          cpf: this.representante_model.cpf
        }
        this.$store.dispatch('cadastroPessoa', { cadUser: body }).then((json) => {
          this.representante_model = { ...this.representante_model, id_pessoa: json.id_pessoa }
          this.posto_model.email = this.representante_model.email
          this.posto_model.cpf = this.representante_model.cpf
          if (json.novo) {
            this.step++
          } else {
            this.step += 2
          }
          this.$emit('info', 'Usuário cadastrado com sucesso')
        }).catch((error) => {
          this.$emit('error', error)
          this.fechar()
        })
      }
    },
    async salvarPosto () {
      if (this.$refs.form3.validate()) {
        try {
          this.buscarCoordenadas()
        } catch (e) {
          console.log(e)
          this.$emit('error', 'Não foi possível encontrar coordenadas geograficas do posto, verifique seu endereço e tente novamente.')
        }
        this.$store.dispatch('cadastroPostoByAdmin', { posto: this.posto_model }).then(() => {
          this.step++
        }).catch((error) => {
          this.$emit('error', error)
          this.fechar()
        })
      }
    },
    buscarCoordenadas () {
      return this.$store.dispatch('pegarCoordenadas', {
        logradouro: this.posto_model.logradouro,
        numero: this.posto_model.numero,
        bairro: this.posto_model.bairro,
        cidade: this.posto_model.cidade,
        estado: this.posto_model.uf
      })
        .then(json => {
          this.posto_model.latitude = json.latitude
          this.posto_model.longitude = json.latitude
        })
    },
    salvarEndereco () {
      this.$store.dispatch('atualizarEnderecoPessoa', { cadUser: this.representante_model }).then(() => {
        this.step++
      })
    },
    clear () {
      this.$refs.form.reset()
    },
    novaFoto () {
      console.log('incluir chamada para a ferramenta de inclusão de foto')
    },
    verificarTelefone () {
      this.$store.dispatch('verificarTelefone', {
        id_pessoa: null,
        telefone: this.representante_model.telefone.slice(3, 11)
      }).then(json => {
        this.verificacaoTelefone = json
      })
    },
    verificarEmail () {
      try {
        this.$store.dispatch('verificarEmail', this.representante_model.email).then((representante) => {
          this.representante_model.nome = representante.nome
          this.representante_model.sobrenome = representante.sobrenome
          this.representante_model.email = representante.email
          this.representante_model.telefone = representante.telefone
          this.representante_model.cpf = representante.cpf
          this.representante_model.id_pessoa = representante.id_pessoa

          this.posto_model.email = this.representante_model.email
          this.posto_model.cpf = this.representante_model.cpf

          if (representante.endereco === null) {
            this.step = 3
          } else {
            this.representante_model.cep = representante.endereco.cep
            this.representante_model.logradouro = representante.endereco.logradouro
            this.representante_model.bairro = representante.endereco.bairro
            this.representante_model.numero = representante.endereco.numero
            this.representante_model.complemento = representante.endereco.complemento
            this.representante_model.cidade = representante.endereco.cidade
            this.representante_model.estado = representante.endereco.estado
            this.step = 4
          }
        }).catch(() => {
          this.step++
        })
      } catch (e) {
        console.log(e)
      }
    }
  },
  watch: {
    'representante_model.telefone' (val) {
      if (val && val.length === 11) {
        this.verificarTelefone()
      } else {
        this.verificacaoTelefone.pessoa = undefined
        this.verificacaoTelefone.ids_cadastrados = []
        this.verificacaoTelefone.cadastrado = false
        this.verificacaoTelefone.quantidade = 0
      }
    }
  }
}
</script>
